export default __webpack_public_path__ + "static/media/video-thumbnail.dc70c638.png";